var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.functypeIcon}}),_vm._v(" "),(_vm.isOffline)?_c('img',{staticStyle:{"position":"absolute"},attrs:{"src":require('../../assets/red_circle.svg')}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b526a40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/device/DeviceAvatar.vue
// module id = null
// module chunks = 